import React, { useState,useEffect } from "react";
import EntityTable from "../components/Entity/Entity";
import { NavLink, useSearchParams } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { API , Auth } from 'aws-amplify';

const EntitySearch = (props) => {

	const [ userInfo , setUserInfo ] = useState(false)
	const [ newSearches , setNewSearches ] = useState(0)
	
	let MAX_SEARCHES = 100000000000000000000000000000000000000
	
	// if (String(localStorage['user_type']) == 'admin') {
	// 	console.log('is an admin')
	// 	MAX_SEARCHES = 100000000000000000000000000000
	// 	console.log(MAX_SEARCHES)
	// }
	// else {
	// 	console.log('is not an admin')
	// 	MAX_SEARCHES = 20
	// 	console.log(MAX_SEARCHES)
	// }
	
	let [searchParams, setSearchParams] = useSearchParams();
	let project_id = searchParams.get("projectid");
	let project_type = searchParams.get("projecttype");
	let search_type = searchParams.get("type");
	const [navLink, setNavLink] = useState('');
	//const [reportid, setReportid] = useState('');

	const handleOnSearch = (report_id) => {
		setNewSearches(newSearches+1)
		//console.log(report_id)
		console.log('report id ' + report_id)
		//setReportid(entity.reportid)
		//console.log('p ' + selectdProject)
		setNavLink(`/entityserachreports?id=${report_id}&create=true`)
		//setErrorMessage('')
		// checkUser(props.user)
	};
	

    const checkUser = async(user) => {
        const token = user.signInUserSession.idToken.jwtToken
        const credentials = await Auth.currentUserCredentials();
        const requestInfo = { headers: { Authorization: token } }
        console.log('checkUser')
        API.get("DocumentSearchUser", `/getuserinfo`, requestInfo)
        .then(response => {
            console.log(response)
            localStorage.setItem('query_searches', response.query_searches)
            localStorage.setItem('entity_searches', response.entity_searches)
            localStorage.setItem('keyword_searches', response.keyword_searches)
            localStorage.setItem('user_type', response.user_type)
        })
        .then(error => {
            console.log(error)
        })
    }
    // useEffect(() => {checkUser(props.user)}, [])
    
   	console.log(newSearches)
	console.log(Number(localStorage['entity_searches']) + newSearches)
	console.log(Number(localStorage['entity_searches']))
	
    if (Number(localStorage['entity_searches']) + newSearches < MAX_SEARCHES) {
		return (
			<Container>
				<EntityTable project_id={project_id} project_type={project_type} search_type={search_type} onSearch={handleOnSearch} />
				<div style={{"display":"flex"}}>
					<NavLink to={navLink}>
						<Button variant="primary">Create Report</Button>{' '}
					</NavLink>
					
				</div>
				<br />
			</Container>
		);
    }
    else {
    	return (
   			<Container>
				<br/>
				<h1>Search Limit Reached!</h1>
				<br/>
				<h2>Sorry, you've reached the maximum number of {MAX_SEARCHES} entity searches for this trial. Please contact Deep Insight Analytics at insight-analytics.ai to create a new subscription</h2>
				<br/>
				<NavLink to={'/'}>
					<Button variant="primary">Return Home</Button>{' '}
				</NavLink>
			</Container>
    	)
    }
};

export default EntitySearch;